class BAOCompleteTheLook extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slider']
  }

  constructor () {
    super()

    this.slider = null

    this.onPreviousClick = this.onPreviousClick.bind(this)
    this.onNextClick = this.onNextClick.bind(this)
  }

  connectedCallback () {
    super.connectedCallback()

    if (!this.shouldUseSlider) return

    this.setupNavigation()
    this.initialiseSlider()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.destroySlider()
  }

  get productCount () {
    return parseInt(this.dataset.productCount, 10) || 0
  }

  get shouldUseSlider () {
    return this.productCount > 3
  }

  setupNavigation () {
    if (this.els.previous?.element) {
      this.listeners.add(
        this.els.previous.element,
        'click',
        this.onPreviousClick,
      )
    }

    if (this.els.next?.element) {
      this.listeners.add(
        this.els.next.element,
        'click',
        this.onNextClick,
      )
    }
  }

  initialiseSlider () {
    if (this.slider) return
    if (!window.KeenSlider) return

    this.slider = new window.KeenSlider(
      this.els.slider.element,
      {
        slides: {
          perView: 1.1,
          spacing: 16,
        },
        rubberband: false,

        created: slider => {
          this.updateNavigation(slider)
        },

        slideChanged: slider => {
          this.updateNavigation(slider)
        },

        detailsChanged: slider => {
          this.updateNavigation(slider)
        },
      },
    )
  }

  onPreviousClick () {
    if (!this.slider) return

    this.slider.prev()
  }

  onNextClick () {
    if (!this.slider) return

    this.slider.next()
  }

  updateNavigation (slider) {
    const currentSlide = slider.track.details.rel + 1

    if (this.els.count?.element) {
      this.els.count.element.textContent = `${currentSlide} of ${this.productCount}`
    }

    if (this.els.previous?.element) {
      this.els.previous.element.disabled = currentSlide === 1
    }

    if (this.els.next?.element) {
      this.els.next.element.disabled = currentSlide === this.productCount
    }
  }

  destroySlider () {
    if (!this.slider) return

    this.slider.destroy()
    this.slider = null
  }
}

if (!customElements.get('bao-complete-the-look')) {
  customElements.define(
    'bao-complete-the-look',
    BAOCompleteTheLook,
  )
}
